import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MembersDomainModel } from '../../../../domainModels/members-domain-model';
import { MemberUserSearchResult } from '../../../../models/users/dto/member-user-search-result';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseComponent } from '../../../../models/base/base-component';

@Component({
  selector: 'app-member-search',
  templateUrl: './member-search.component.html',
  styleUrls: ['./member-search.component.scss']
})
export class MemberSearchComponent extends BaseComponent {
  @Input() employerId!: number;
  @Input() disabled = false;
  @Input() required = true;
  @Input() clearSearchTrigger: EventEmitter<void> = new EventEmitter<void>();
  @Input() label = $localize`Member Search`;
  @Output() selectedMemberId = new EventEmitter<number>();

  private membersDomainModel = inject(MembersDomainModel);

  public memberSearchFunction = (searchString: string) => {
    return this.membersDomainModel.searchMembersByIdOrName(searchString, this.employerId);
  };

  private _selectedMember = new BehaviorSubject<MemberUserSearchResult | null>(null);
  public selectedMember$ = this._selectedMember as Observable<MemberUserSearchResult | null>;
  public setSelectedMember = (member: MemberUserSearchResult | null) => this._selectedMember.next(member);

  private listenToSelectedMemberId = this.selectedMember$.subscribeWhileAlive({
    owner: this,
    next: member => this.selectedMemberId.emit(member?.id)
  });

  setupBindings(): void {}

  setupViews(): void {}
}
